var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19.999,
    r: 19,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7131 28.998V15.9071H15.2614V28.998H12.7131ZM14 13.8873C13.5568 13.8873 13.1761 13.7395 12.858 13.4441C12.5455 13.1429 12.3892 12.785 12.3892 12.3702C12.3892 11.9498 12.5455 11.5918 12.858 11.2963C13.1761 10.9952 13.5568 10.8446 14 10.8446C14.4432 10.8446 14.821 10.9952 15.1335 11.2963C15.4517 11.5918 15.6108 11.9498 15.6108 12.3702C15.6108 12.785 15.4517 13.1429 15.1335 13.4441C14.821 13.7395 14.4432 13.8873 14 13.8873ZM21.2379 21.2253V28.998H18.6896V15.9071H21.1357V18.0378H21.2976C21.5987 17.3446 22.0703 16.7878 22.7124 16.3674C23.3601 15.9469 24.1754 15.7367 25.1584 15.7367C26.0504 15.7367 26.8317 15.9242 27.5021 16.2992C28.1726 16.6685 28.6925 17.2196 29.0618 17.9526C29.4311 18.6855 29.6158 19.5918 29.6158 20.6713V28.998H27.0675V20.9782C27.0675 20.0293 26.8203 19.2878 26.326 18.7537C25.8317 18.214 25.1527 17.9441 24.2891 17.9441C23.6982 17.9441 23.1726 18.0719 22.7124 18.3276C22.2578 18.5833 21.897 18.9583 21.63 19.4526C21.3686 19.9412 21.2379 20.5321 21.2379 21.2253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.8b1596c6c1fddf109dff16bc1ee46336.svg";
export { ForwardRef as ReactComponent };